import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "save",
  "use": "save-usage",
  "viewBox": "0 0 192 192",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 192\" id=\"save\"><title>ic-save</title><g id=\"save_save\"><g id=\"save_expanded-5\" data-name=\"expanded\"><path d=\"M157.92,51.25,140.75,34.08a7.11,7.11,0,0,0-5-2.08H39.11A7.11,7.11,0,0,0,32,39.11V152.89A7.11,7.11,0,0,0,39.11,160H152.89a7.11,7.11,0,0,0,7.11-7.11V56.28A7.11,7.11,0,0,0,157.92,51.25ZM128,80H56V48h72Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol